// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__Yqlzt","right":"PageHeader_right__bZHVL","button":"PageHeader_button__Q1Eic","burger":"PageHeader_burger__qnBvx"};